import React, { Component } from 'react'
import {Link, Redirect} from 'react-router-dom'
import CardFormulario from '../../../../Utils/Cards/cardFormulario';
import LoadMask from '../../../../Utils/LoadMask/LoadMask';

import TrasladoForm from './TrasladoForm';


export default class InventarioTransicion extends Component {
    componentDidMount(){
        let id = this.props.match.params.id
        if (id != undefined && id != null){
            this.props.setProductoDespacho(
                {
                    bodega:this.props.match.params.id,
                    //orden:this.props.match.params.id
                }
            )
        }else{
            return (<Redirect to="/bodegas" />)
        }
    }
    handleSubmit = (values) => {
        const { realizarTrasladoInventarioMP } = this.props

        let bodegaId = this.props.match.params.id
        realizarTrasladoInventarioMP(values, bodegaId);
    }

    render() {
        const {loader, item } = this.props;

        if (this.props.permisos.crear_editar_bodegas === false) return <Redirect to="/bodegas" />

        return (
            <CardFormulario titulo={"Traslado a Producción"}>
                <LoadMask loading={loader} light type={"TailSpin"}>
                    <TrasladoForm
                        orden={this.props.match.params.id}
                        bodega={this.props.match.params.id}
                        onSubmit={this.handleSubmit}
                        item={item}
                        initialValues={{tipo_movimiento:30, descripcion:""}}
                    />
                </LoadMask>
            </CardFormulario>
        )
    }
}
